namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class ReportTemplateDialog extends Serenity.TemplatedDialog<any> {
        public isclosed: boolean;
        public reportkey: string;
        public getTemplate() {
            var _reportkey = this.options.reportkey;
                  return       `<div id="GridDiv" style="height: 800px;margin:0px 15px 0px"></div>

            <script type="text/javascript">
                jQuery(function () {
                    new `+ _reportkey  + `($('#GridDiv'), {}).init();

                    Q.autoFullHeight($('#GridDiv'));
                });
            </script>

            <script type="text/javascript" src="/Scripts/apexcharts/apexcharts.js"></script>
<link rel="stylesheet" href="/Scripts/SlickGrid/Plugins/slick.columngroup.css">
    <script src="/Scripts/SlickGrid/Plugins/slick.columngroup.js"></script>
<script src="/Scripts/SlickGrid/Plugins/slick.autocolumnsize.js"></script>`
        }
        public checkGrid;
        constructor(options) {
            super(options);
            this.reportkey = options.reportkey; 
            this.dialogTitle = options.title;  
        }

        onSuccess = () => { this.checkGrid.refresh(); return 0; }

        getDialogOptions() {
            let opt = super.getDialogOptions();
            opt.width = 1500;
            return opt
        }
        protected onDialogOpen() {
            jQuery(".ui-dialog-titlebar-maximize").click();
            super.onDialogOpen();

        }

    }
}